import React, { useState } from 'react';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router';
import { useToast } from '../Hooks/useToast';
import * as Yup from 'yup';

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import logoimg from "./../Assets/Imgs/Main_Logo.png"

import { FetchAdminLogin } from '../Apis/Auth/Admin_Login';
import { FetchAdminForgotPassword } from '../Apis/Auth/Admin_Login';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);
  const [forgotPasswordOpen, setForgotPasswordOpen] = useState(false);
  const { toastSuccess, toastError } = useToast();

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email('Invalid email address')
        .max(200, 'Must be 200 characters or less')
        .required(' Email ist erforderlich'),
      password: Yup.string()
        .max(200, 'Must be 200 characters or less')
        .min(7, 'Must be at least 7 characters')
        .required('Passwort ist erforderlich'),
    }),
    onSubmit: async (values) => {
      try {
        const success = await FetchAdminLogin(values);
        if (success) {
          toastSuccess("Login erfolgreich!");
          navigate("/"); 
          window.location.reload();  
        } else {
          toastError("Login fehlgeschlagen. Bitte überprüfen Sie Ihre Daten.");
        }
      } catch (error) {
        console.error("Login error:", error);
        toastError("Ein Fehler ist beim Login aufgetreten.");
      }
    }
    
  });

  const forgotPasswordFormik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email('Ungültige E-Mail-Adresse')
        .required('E-Mail ist erforderlich'),
    }),
    onSubmit: async (values) => {
      try {
        const success = await FetchAdminForgotPassword({ email: values.email });
        
        if (success) {
          toastSuccess("Passwort-Link wurde an Ihre E-Mail gesendet!");
          setForgotPasswordOpen(false);
        } else {
          toastError("Fehler beim Senden des Reset-Links");
        }
      } catch (error) {
        console.error("Error in forgot password:", error);
        toastError("Fehler beim Senden des Reset-Links");
      }
    }
  });

  return (
    <Box sx={{
      backgroundColor: { lg: "#D6B981" },
      height: '100vh',
      display: { lg: 'flex' },
      justifyContent: { lg: 'center' },
      alignItems: { lg: 'center' },
    }}>
      <Card sx={{
        flexDirection: {xs:"column", lg:"row"},
        alignItems: "center",
        display: "flex",
        borderRadius: { lg: '20px' },
        width: { lg: '70%' },
        height: { xs: '100vh', lg: 'auto' },
        boxShadow: { lg: '40px', xs: 'none' },
        px: { xs: '10px', lg: '40px' },
        py: {md:"100px", lg:"30px"},
        backgroundColor: "#F0EAD6",
        pt: {xs: 10}
      }}>
        <Grid container spacing={2} sx={{ width: {xs:"85%", lg:"50%"}, order: { xs: 2, lg: 1 } }}>
          <Grid size={{ xs: 12, lg: 6 }}>
            <CardHeader sx={{ display: {md:"flex", xs:"none"} }} 
              avatar={
                <Avatar sx={{ bgcolor: "#D6B981" }}>
                  <LockOutlinedIcon sx={{ color: 'white' }} />
                </Avatar>
              }
              title={<Typography sx={{ color: "#D6B981" }}>Sign in</Typography>}
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Typography sx={{ paddingBottom: 2, color: "#D6B981" }}>Username</Typography>
            <TextField
              fullWidth
              name="email"
              type="text"
              placeholder="benutzer@beispiel.de"
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
              {...formik.getFieldProps('email')}
              sx={{
                '& .MuiInputBase-input': { color: 'black' },
                '& .MuiOutlinedInput-root': {
                  borderRadius: '12px',
                  color: '#E1DDD2',
                  '& fieldset': { borderColor: "#D6B981", borderWidth: '2px' },
                  '&:hover fieldset': { borderColor: '#B89B60' }, 
                  '&.Mui-focused fieldset': { borderColor: "black" }
                }
              }}
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Typography sx={{ paddingBottom: 2, color: "#D6B981" }}>Password</Typography>
            <TextField
              fullWidth
              placeholder="*******"
              type="password"
              autoComplete="current-password"
              error={formik.touched.password && Boolean(formik.errors.password)}
              helperText={formik.touched.password && formik.errors.password}
              {...formik.getFieldProps('password')}
              sx={{
                '& .MuiInputBase-input': { color: 'black' },
                '& .MuiOutlinedInput-root': {
                  borderRadius: '12px',
                  color: '#E1DDD2',
                  '& fieldset': { borderColor: "#D6B981", borderWidth: '2px' },
                  '&:hover fieldset': { borderColor: '#B89B60' },
                  '&.Mui-focused fieldset': { borderColor: "black" }
                }
              }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                  sx={{
                    '&.Mui-checked': { color: "#D6B981" },
                    '& .MuiSvgIcon-root': { fill: "#D6B981" },
                    '&.Mui-checked .MuiSvgIcon-root': { fill: "#D6B981" }
                  }}
                />
              }
              label="Angemeldet bleiben"
              sx={{ marginTop: 1, color: "#D6B981" }}
            />
            <Typography 
              sx={{ 
                color: "#D6B981", 
                textDecoration: 'underline', 
                cursor: 'pointer',
                mt: 1,
                fontSize: '0.875rem'
              }}
              onClick={() => setForgotPasswordOpen(true)}
            >
              Passwort vergessen?
            </Typography>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <CardActions>
              <Button
                sx={{
                  paddingY: '12px',
                  borderRadius: '12px',
                  backgroundColor: "#D6B981",
                  color: 'white'
                }}
                type="submit"
                fullWidth
                onClick={formik.submitForm}
              >
                Anmelden
              </Button>
            </CardActions>
          </Grid>
        </Grid>
        <Box sx={{
          order: { xs: 1, lg: 2 },
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
          borderRadius: '100%',
          width: {lg:"50%"}
        }}>
          <CardMedia
            component="img"
            image={logoimg}
            sx={{
              objectFit: 'cover',
              width: { xs: '40%', md:"30%", lg: '70%' }
            }}
          />
        </Box>
      </Card>

      <Dialog  open={forgotPasswordOpen} onClose={() => setForgotPasswordOpen(false)}>
        <DialogTitle sx={{ color: "#D6B981", fontWeight: 'bold' }}>
          Passwort zurücksetzen
        </DialogTitle>
        <form onSubmit={forgotPasswordFormik.handleSubmit}>
          <DialogContent >
            <TextField
              fullWidth
              name="email"
              label="E-Mail-Adresse"
              variant="outlined"
              value={forgotPasswordFormik.values.email}
              onChange={forgotPasswordFormik.handleChange}
              onBlur={forgotPasswordFormik.handleBlur}
              error={forgotPasswordFormik.touched.email && Boolean(forgotPasswordFormik.errors.email)}
              helperText={forgotPasswordFormik.touched.email && forgotPasswordFormik.errors.email}
              margin="normal"
              sx={{
                '& .MuiInputBase-root': {
                  '& fieldset': { borderColor: "#D6B981" },
                  '&:hover fieldset': { borderColor: '#B89B60' }
                }
              }}
            />
          </DialogContent>
          <DialogActions sx={{px:20,py:4 }}>
            <Button 
              onClick={() => setForgotPasswordOpen(false)} 
              sx={{ color: "#D6B981" }}
            >
              Abbrechen
            </Button>
            <Button
              type="submit"
              variant="contained"
              sx={{ backgroundColor: "#D6B981", color: 'white' }}
            >
              Link senden
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </Box>
  );
};

export default AdminLogin;